import React from 'react';
import clsx from 'clsx';

import { getAddress, getCenterName } from '../../utils/card';
import SearchContext from '../../templates/Search/SearchContext';

interface Props {
  item: {
    id: string;
    markerRef: React.RefObject<unknown>;
    publicInformation: {
      address: {
        location: {
          x: number;
          y: number;
        };
      };
    };
  };
  onClick: (item: object) => any;
  className: string;
}

// TODO: make generic the component (gregory)
const CenterItem = React.forwardRef<HTMLDivElement, Props>(
  ({ item, onClick, className, ...restProps }, ref) => {
    const ctx = React.useContext(SearchContext);
    const hasCtx = !!ctx;
    const timeoutId = React.useRef<NodeJS.Timeout | undefined>();

    const onMouseEnter = React.useCallback(() => {
      if (!hasCtx) return;
      ctx.setHighlightItemId(item.id);
      const fly = async () => {
        const FlyToInterpolator = (
          await import(
            'react-map-gl/dist/es6/utils/transition/viewport-fly-to-interpolator'
          )
        ).default;
        ctx.setMapViewport({
          longitude: item.publicInformation.address.location.x,
          latitude: item.publicInformation.address.location.y,
          zoom: 17,
          bearing: 0,
          pitch: 0,
          transitionDuration: 500,
          transitionInterpolator: new FlyToInterpolator(),
        });
      };
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
      timeoutId.current = setTimeout(fly, 2000);
    }, [item]);
    const onMouseLeave = React.useCallback(() => {
      if (!hasCtx) return;
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
        timeoutId.current = undefined;
      }
      ctx.setMapViewport(ctx.mapViewportDefault);
      if (!(item.markerRef && item.markerRef.current)) return;
      ctx.setHighlightItemId(null);
    }, [item, ctx?.mapViewportDefault]);

    return (
      <div
        className={clsx(className, 'popup-select--item')}
        ref={ref}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={() => onClick(item)}
        {...restProps}
      >
        <strong>{`${getCenterName(item)}`}</strong>
        <br />
        {`${getAddress(item)}`}
      </div>
    );
  },
);

CenterItem.displayName = 'ItemCard';

export default CenterItem;
